module.exports = __webpack_public_path__ + "img/tree_nuts.20838b15.jpg";